import SystemMessage from './SystemMessage';
export default SystemMessage;
